import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";
import VoucherDetailModal from "./VoucherDetailModal";

export default function DetailModal({
    loteVoucherId, closeModal, updateList
}) {
    return (
        <>
            <VoucherDetailModal loteVoucherId={loteVoucherId} updateLotes={updateList} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>
        </>
    );
}